import * as uiTypes from '../types/uiTypes';

import imgNode2 from '../../assets/images/svg/heim-icon.png';
import imgNode3 from '../../assets/images/svg/freya-icon.png';
import imgNode1 from '../../assets/images/svg/thor-icon.png';
import imgNode4 from '../../assets/images/svg/odin-icon.png';

import imgNodeGold2 from '../../assets/images/svg/heim-icon-gold.png';
import imgNodeGold3 from '../../assets/images/svg/freya-icon-gold.png';
import imgNodeGold1 from '../../assets/images/svg/thor-icon-gold.png';
import imgNodeGold4 from '../../assets/images/svg/odin-icon-gold.png';

const initialState = {
  theme: localStorage.getItem('theme') || 'dark',
  loading: { walletConnection: false, dapp: false },
  snackbar: { open: false, severity: 'success', message: '', transactionHash: '' },
  modal: { open: false, varaint: 'loading', text: '', secondaryText: '' },
  initialRender: true,
  nodesData: [
    { img: imgNode2, hoverImg: imgNodeGold2, noded: 0, name: 'heimdall' },
    { img: imgNode3, hoverImg: imgNodeGold3, noded: 0, name: 'freya' },
    { img: imgNode1, hoverImg: imgNodeGold1, noded: 0, name: 'thor' },
    { img: imgNode4, hoverImg: imgNodeGold4, noded: 0, name: 'odin' },
  ],
  toggleSidebar: false,
  activeLink: { prev: 0, next: 0,start: false,initial:  true },
};

const uiReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case uiTypes.TOGGLE_THEME:
      const theme = state.theme === 'dark' ? 'light' : 'dark';
      localStorage.setItem('theme', theme);
      return { ...state, theme };
    case uiTypes.LOADING:
      return { ...state, loading: { ...state.loading, ...payload } };
    case uiTypes.SHOW_SNACKBAR:
      return { ...state, snackbar: { open: true, transactionHash: '', ...payload } };
    case uiTypes.HIDE_SNACKBAR:
      return { ...state, snackbar: { open: false, transactionHash: '' } };
    case uiTypes.SHOW_SNACKBAR_INDEEP:
      return { ...state, snackbar: { open: true, ...payload } };
    case uiTypes.INITIALLY_RENDERED:
      return { ...state, initialRender: false };
    case uiTypes.SHOW_MODAL:
      return { ...state, modal: payload };
    case uiTypes.UPDATE_NODED:
      const newNodesData = [...state.nodesData];
      newNodesData[payload.idx].noded = payload.noded;
      return { ...state, nodesData: newNodesData };
    case uiTypes.TOGGLE_SIDEBAR:
      return { ...state, toggleSidebar: payload };
    case uiTypes.SET_ACTIVE_LINK:
      if (payload.prev) {
        return { ...state, activeLink: { ...state.activeLink, prev: state.activeLink.next, start: false } };
      } else if (payload.initial){
        return { ...state, activeLink: { ...state.activeLink,prev:0, next: payload.idx, start: true,initial: false } };
      } else {
        return { ...state, activeLink: { ...state.activeLink, next: payload.idx, start: true } };
      }
    default:
      return state;
  }
};

export default uiReducer;
